<script lang="ts">
  import type { Snippet } from 'svelte'

  const {
    children,
    onClick,
    variant = 'default',
  }: {
    children: Snippet
    onClick: () => void
    variant?: 'default' | 'destructive'
  } = $props()
</script>

<button
  class="context-menu-item"
  class:destructive={variant === 'destructive'}
  onclick={onClick}
>
  {@render children()}
</button>

<style lang="scss">
  .context-menu-item {
    background: none;
    border: none;
    color: var(--context-menu-foreground);
    cursor: pointer;
    display: flex;
    font-size: 0.75rem;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-height: 2rem;
    padding: 0 1rem;

    &:hover {
      background-color: var(--context-menu-hover-background);

      &.destructive {
        color: var(--button-destructive-foreground);
        background: var(--button-destructive-background);
      }
    }

    &:focus-visible {
      outline: 1px solid var(--stroke);
      outline-offset: -3px;
    }
  }
</style>
